import { ScreenFrame } from '@labflow/ui';
import type { ReactNode } from 'react';

export interface StatusScreenProps {
  title: string;
  /** 원인 한 줄 — 버튼이 이미 말하는 것을 다시 쓰지 않는다(D5 §8). */
  description?: string;
  actions: ReactNode;
}

/** 본문 자리를 대신하는 상태 화면 — 없는 경로·화면 오류. 다른 화면과 같은 머리·거터에 선다. */
export function StatusScreen({ title, description, actions }: StatusScreenProps) {
  return (
    <ScreenFrame title={title} width="read" gap="card">
      {description ? <p className="text-ink text-sm">{description}</p> : null}
      <div className="gap-snug flex flex-wrap">{actions}</div>
    </ScreenFrame>
  );
}
